import { useQuery } from '@tanstack/react-query';
import { get } from 'api/base';
import { useMe } from 'hooks/auth';
import type { FlagEvaluation } from 'types/backend';

const SIGNED_OUT: FlagEvaluation = { userId: '', organizationId: null, flags: {} };

export function useFlagEvaluationQuery() {
  const { data: me } = useMe();
  return useQuery({
    queryKey: ['featureFlags', me?.id, me?.activeOrganization],
    queryFn: () => get('featureFlags') as Promise<FlagEvaluation>,
    staleTime: Infinity,
    retry: false,
    enabled: !!me,
  });
}

export function useFlagEvaluation(): FlagEvaluation {
  return useFlagEvaluationQuery().data ?? SIGNED_OUT;
}
